import { useProfile } from "../../context/ProfileContext";

export const useColor = () => {
  const { profileData } = useProfile();

  const getColor = (type, key) => {
    return profileData?.colorSettings?.[type]?.[key] || null;
  };

  return { getColor };
};
